import { render } from "./EvaluateView.vue?vue&type=template&id=3c71c63b&scoped=true"
import script from "./EvaluateView.vue?vue&type=script&lang=js"
export * from "./EvaluateView.vue?vue&type=script&lang=js"

import "./EvaluateView.vue?vue&type=style&index=0&id=3c71c63b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c71c63b"]])

export default __exports__